import { render, staticRenderFns } from "./AccountThinkBanner.vue?vue&type=template&id=7934cd6a&scoped=true&"
import script from "./AccountThinkBanner.vue?vue&type=script&lang=js&"
export * from "./AccountThinkBanner.vue?vue&type=script&lang=js&"
import style0 from "./AccountThinkBanner.vue?vue&type=style&index=0&id=7934cd6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7934cd6a",
  null
  
)

export default component.exports